export const convertUTCDateToLocalDate = date => {
	let newDate = new Date(date);
	newDate.setMinutes(date.getMinutes() - date.getTimezoneOffset());
	return newDate;
};

export const userIsBot = /bot|googlebot|prerender|crawler|spider|robot|crawling/i.test(navigator.userAgent);

export const dateFormatShort = {
	dateStyle: 'short',
	timeStyle: 'short',
	timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
};
export const dateFormatLong = {
	dateStyle: 'medium',
	timeStyle: 'medium',
	timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
};

export function formatDateString(d) {
	if (d == null) return '';

	// Add UTC Offset, else it parses is as local datetime
	d = d.slice(0, 19) + '.000Z';

	return new Intl.DateTimeFormat('el-GR', dateFormatLong).format(new Date(d));
}

export const getGenderLabel = genderId => {
	let gender = '';

	if (genderId == 1) {
		gender = 'male';
	} else if (genderId == 2) {
		gender = 'female';
	} else if (genderId == 3) {
		gender = 'other';
	} else if (genderId == 4) {
		gender = 'noDisclose';
	}

	return gender;
};

export const isEmpty = obj => {
	return Object.keys(obj).length === 0;
};

export const emptyProfile = () => {
	return {
		eml: '',
		mob: '',
		dob: '',
		gd: '',
		fn: '',
		ln: '',
		id: ''
	};
};

export const sortLabels = arr => {
	return arr.sort((a, b) => (a.label > b.label ? 1 : b.label > a.label ? -1 : 0));
};

export function formatAmountValue(value) {
	if (value != null) {
		return value.toFixed(2).toString() + '€';
	}

	return '';
}

export function formatRoundValue(value) {
	if (value != null) {
		return value.toFixed(0).toString();
	}

	return null;
}
export function formatPercentValue(value) {
	if (value != null) {
		return value.toString() + '%';
	}

	return null;
}

export function calculateProductPrice(product, dimensionId) {
	const priceValue = calculateProductPriceValue(product, dimensionId);
	return formatAmountValue(priceValue);
}

export function calculateProductPriceValue(product, dimensionId) {
	let price = product.prc;

	if (dimensionId) {
		const dimension = product.dimensions.find(x => x.id == dimensionId);

		if (dimension?.prc) {
			if (dimension.prcbd > 0) {
				price = dimension.prc;
			} else if (dimension.dsc > 0 && dimension.dsc < 100) {
				price = dimension.prc - (dimension.prc * dimension.dsc) / 100;
			}

			return roundToTwo(price);
		}
	}

	if (product.prcbd > 0) {
		price = product.prc;
	} else if (product.dsc > 0 && product.dsc < 100) {
		price = product.prc - (product.prc * product.dsc) / 100;
	}

	return roundToTwo(price);
}

// Mirrors ProductToken.CalculatePriceBD (server): a fixed-price discount (prcbd > prc) exposes prcbd
// as the crossed-out price, a percentage discount (dsc) exposes prc; otherwise there is none.
function priceBDFrom(entry) {
	if (entry.prcbd > entry.prc) {
		return entry.prcbd;
	}

	if (entry.prcbd > 0) {
		return 0;
	}

	if (entry.dsc > 0 && entry.dsc < 100) {
		return entry.prc;
	}

	return 0;
}

export function calculateProductPriceBDValue(product, dimensionId) {
	if (dimensionId) {
		const dimension = product.dimensions.find(x => x.id == dimensionId);

		if (dimension?.prc) {
			return roundToTwo(priceBDFrom(dimension));
		}
	}

	return roundToTwo(priceBDFrom(product));
}

function roundToTwo(num) {
	return +(Math.round(num + 'e+2') + 'e-2');
}
export function calculateProductPriceBD(product, dimensionId) {
	const priceValue = calculateProductPriceValue(product, dimensionId);
	const priceBD = calculateProductPriceBDValue(product, dimensionId);

	return priceBD > priceValue ? formatAmountValue(priceBD) : null;
}

export function calculateProductReferencePriceValue(product, dimensionId) {
	let referencePrice = product.rprc ?? 0;

	if (dimensionId) {
		const dimension = product.dimensions.find(x => x.id == dimensionId);

		if (dimension?.rprc) {
			referencePrice = dimension.rprc;
		}
	}

	return roundToTwo(referencePrice);
}

// Mirrors ProductToken.CalculateDiscountPercentage (server): fixed-price discounts derive the
// percentage from prcbd vs prc, percentage discounts use dsc as-is.
function discountPercentageFrom(entry) {
	if (entry.prcbd > entry.prc) {
		return (1 - entry.prc / entry.prcbd) * 100;
	}

	if (entry.prcbd > 0) {
		return 0;
	}

	if (entry.dsc > 0 && entry.dsc < 100) {
		return entry.dsc;
	}

	return 0;
}

export function calculateProductDiscount(product, dimensionId) {
	let source = product;

	if (dimensionId) {
		const dimension = product.dimensions.find(x => x.id == dimensionId);

		if (dimension?.prc) {
			source = dimension;
		}
	}

	return formatRoundValue(discountPercentageFrom(source));
}
//export const setPassVisibillityClickListener = () => {
//    $('#togglePassVisibillity').click(function () {
//        let passInput = $(this).parent().find('input');
//        let showIcon = $(this).find('#showPassIcon');
//        let hideIcon = $(this).find('#hidePassIcon');

//        if ($(passInput).prop("type") == 'text') {
//            $(passInput).prop("type", "password");
//            $(showIcon).show();
//            $(hideIcon).hide();
//        } else {
//            $(passInput).prop("type", "text");
//            $(hideIcon).show();
//            $(showIcon).hide();
//        }
//    });
//};

export function normalize(text) {
	return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

export function parseJwt(token) {
	var base64Url = token.split('.')[1];
	var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
	var jsonPayload = decodeURIComponent(
		window
			.atob(base64)
			.split('')
			.map(function (c) {
				return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
			})
			.join('')
	);

	return JSON.parse(jsonPayload);
}

// Meta retires each Graph API version roughly two years after release, and calls made against a
// retired one are silently auto-upgraded to the oldest surviving version — which is how the login
// ended up riding v20.0 while this file still said v9.0 (BA-7881). Pin it explicitly here, in one
// place, and re-check against https://developers.facebook.com/docs/graph-api/changelog/versions/
// well before v26.0 (released 29/07/2026) reaches its own expiry date.
export const FACEBOOK_GRAPH_API_VERSION = 'v26.0';

// The profile fetch below bypasses the JS SDK, so FB.init's version does not cover it — it needs
// the version segment in the path or Meta falls back to the app's default version in the console.
export const getFacebookProfileUrl = (userId, accessToken) =>
	`https://graph.facebook.com/${FACEBOOK_GRAPH_API_VERSION}/${userId}` +
	`?fields=id,first_name,last_name,email&access_token=${accessToken}`;

export const initFacebookSdk = () => {
	return new Promise(resolve => {
		// wait for facebook sdk to initialize before starting the react app
		window.fbAsyncInit = function () {
			window.FB.init({
				appId: __BW_ENV__.REACT_APP_FACEBOOK_APP_ID,
				cookie: false,
				xfbml: true,
				version: FACEBOOK_GRAPH_API_VERSION
			});

			resolve();
		};

		// load facebook sdk script
		(function (d, s, id) {
			var js,
				fjs = d.getElementsByTagName(s)[0];
			if (d.getElementById(id)) {
				return;
			}
			js = d.createElement(s);
			js.id = id;
			js.src = 'https://connect.facebook.net/en_US/sdk.js';
			fjs.parentNode.insertBefore(js, fjs);
		})(document, 'script', 'facebook-jssdk');
	});
};

export const getEntityImages = entity => {
	if (!entity || typeof entity !== 'object') return [];

	const imageProperties = Object.keys(entity).filter(key => key.startsWith('img') && !key.startsWith('imgdel'));

	return imageProperties.map(imgProp => entity[imgProp]).filter(val => val !== null && val !== undefined);
};

// Group product color dimensions by display name, keeping the variant that actually has a hex.
// Duplicated ERP color codes (a legacy value with a hex plus a newer synced value with an empty hex)
// otherwise render as two swatches, one of them white — see VA-10839. If a name has two different
// non-empty hexes (genuine ambiguity) the first hex-bearing row in feed order wins; if none has a hex
// the first row is kept as-is (hex-less swatch) rather than dropped.
export const groupColorsByName = dimensions => {
	if (!Array.isArray(dimensions)) return [];

	return [
		...dimensions
			.filter(item => item.cval)
			.reduce((map, item) => {
				const existing = map.get(item.cvtxt);
				if (!existing || (!existing.chex && item.chex)) map.set(item.cvtxt, item);
				return map;
			}, new Map())
			.values()
	];
};

// Sizes for a color span every dimension-value id that shares the color name, not just one `cval`,
// because the same color can exist under multiple ERP codes (VA-10839).
export const getSizesForColorName = (dimensions, colorName) => {
	if (!Array.isArray(dimensions)) return [];

	const colorDimensionIds = dimensions.filter(x => x.cvtxt === colorName && x.cval).map(y => y.id);
	return dimensions.filter(x => x.cval == null && colorDimensionIds.includes(x.id));
};

// Picks the cart-line thumbnail for a chosen SKU: prefer an image from any dimension sharing the
// selected color, grouped by color id (`cval`) rather than hex so an empty hex neither throws nor
// matches unrelated colors (VA-10839). Falls back to the product image.
export const getCartLineImage = (items, dimensionId, product) => {
	let imagePath = '';

	try {
		const selectedColorItem = Array.isArray(items) ? items.find(i => i.id === dimensionId && i.cval) : null;
		const selectedCval = selectedColorItem?.cval;
		const groupedByColorItems = selectedCval ? items.filter(i => i.cval === selectedCval) : [];

		for (let i = 0; i < groupedByColorItems.length; i++) {
			imagePath = getEntityImages(groupedByColorItems[i]).at(0) || '';
			if (imagePath) break;
		}

		if (imagePath === '') {
			imagePath = getEntityImages(product).at(0) || '';
		}
	} catch (error) {}

	return imagePath;
};
